// Redux Action Types - Previously in states/index.js
export const APP_CONTROLLER_ACTIONS = {
  UPDATE_MENU: "UPDATE_MENU",
  GET_USER: "GET_USER", 
  CATEGORY_TABS: "CATEGORY_TABS",
  FILTER_DELAY: "FILTER_DELAY",
  GET_DOCUMENT: "GET_DOCUMENT",
  UPDATE_PO: "UPDATE_PO",
  GET_PO_LIST: "GET_PO_LIST",
  GET_ALERT_INFO: "GET_ALERT_INFO",
  SHOW_BADGE: "SHOW_BADGE",
  PO_LINE: "PO_LINE",
  EDIT_PO: "EDIT_PO",
  ADD_SUPPLIER: "ADD_SUPPLIER",
  PO_ID: "PO_ID",
  LOGIN: "LOGIN",
  CHANGE_INCOTERM: "CHANGE_INCOTERM",
  REQUEST_UPDATE: "REQUEST_UPDATE",
  DOCUMENT_UPLOAD: "DOCUMENT_UPLOAD"
}; 